import React from 'react';

interface QuitGameModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function QuitGameModal({ open, onCancel, onConfirm }: QuitGameModalProps): JSX.Element | null {
  if (!open) return null;

  return (
    <div className="quit-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="quit-title">
      <div className="quit-modal-card">
        <h5 id="quit-title" className="mb-2">Quit to Profile</h5>
        <p className="mb-3">This clears local game data and returns you to profile setup.</p>
        <div className="d-flex gap-2 justify-content-end">
          <button type="button" className="btn btn-outline-light btn-sm" onClick={onCancel}>Cancel</button>
          <button type="button" className="btn btn-danger btn-sm" onClick={onConfirm}>Quit</button>
        </div>
      </div>
    </div>
  );
}
